<rrs-account-loyalty></rrs-account-loyalty>
<rrs-account-navigation></rrs-account-navigation>
<div class="account-content">
  <router-outlet></router-outlet>
</div>
